export default "__VITE_ASSET__Dlka7OMM__"